import {Col, Row} from "antd";
import {CreateNewServiceButton} from "./create-service-button";
import {StyledServiceOrderListHeaderTitle} from "../orders/header/styles";
import {StyledPageHeaderWrapper} from "../../../calls/upcoming-calls/upcoming-calls.style";

export function ServiceListHeader() {
  return (
    <StyledPageHeaderWrapper>
      <StyledServiceOrderListHeaderTitle>Services</StyledServiceOrderListHeaderTitle>
      <CreateNewServiceButton />
    </StyledPageHeaderWrapper>
  );
}
